import moment from 'moment';
import { Application } from '../../apiModels';

export const pendingApplicationsProfiles: Record<string, Application[]> = {
  ALL_TYPES: [
    {
      id: 1,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'PAYMENT_RATE',
      details: {
        paymentRate: 6,
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
      },
    },
    {
      id: 2,
      status: 'COMPLETE',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'PAYMENT',
      details: {
        amount: 1500,
        currency: 'EUR',
        targetFund: {
          name: 'Tuleva III Samba Pensionifond',
          fundManager: { name: 'Tuleva' },
          pillar: 3,
          isin: 'EE3600001707',
          ongoingChargesFigure: 0.0049,
          nav: 1,
          managementFeeRate: 0.0049,
          status: 'ACTIVE',
          inceptionDate: '2020-01-01',
        },
      },
    },

    {
      id: 4,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'STOP_CONTRIBUTIONS',
      details: {
        stopTime: '2025-08-01T00:00:00Z',
        earliestResumeTime: '2026-01-01T00:00:00Z',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 5,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'RESUME_CONTRIBUTIONS',
      details: {
        resumeTime: '2025-08-01T00:00:00Z',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 6,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'EARLY_WITHDRAWAL',
      details: {
        depositAccountIBAN: 'EE123456789012345678',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
      },
    },
    {
      id: 7,
      status: 'COMPLETE',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'WITHDRAWAL',
      details: {
        depositAccountIBAN: 'EE123456789012345678',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
      },
    },
    {
      id: 8,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'FUND_PENSION_OPENING',
      details: {
        depositAccountIBAN: 'EE987654321098765432',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
        fundPensionDetails: {
          durationYears: 20,
          paymentsPerYear: 12,
        },
      },
    },
    {
      id: 9,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'FUND_PENSION_OPENING_THIRD_PILLAR',
      details: {
        depositAccountIBAN: 'EE987654321098765432',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
        fundPensionDetails: {
          durationYears: 10,
          paymentsPerYear: 4,
        },
      },
    },
    {
      id: 10,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'PARTIAL_WITHDRAWAL',
      details: {
        depositAccountIBAN: 'EE112233445566778899',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        fulfillmentDate: moment().add(14, 'days').toISOString(),
      },
    },
    {
      id: 11,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'WITHDRAWAL_THIRD_PILLAR',
      details: {
        depositAccountIBAN: 'EE998877665544332211',
        fulfillmentDate: moment().add(7, 'days').toISOString(),
        cancellationDeadline: null,
      },
    },
    {
      id: 3,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'TRANSFER',
      details: {
        sourceFund: {
          fundManager: { name: 'Swedbank' },
          isin: 'EE3600109442',
          name: 'Swedbank II',
          managementFeeRate: 0.0034,
          pillar: 2,
          ongoingChargesFigure: 0.0096,
          nav: 1,
          status: 'ACTIVE',
          inceptionDate: '2017-01-01',
        },
        exchanges: [
          {
            targetFund: {
              name: 'Tuleva Maailma Aktsiate Pensionifond',
              fundManager: { name: 'Tuleva' },
              pillar: 2,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0049,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 0.5,
          },
        ],
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 12,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'TRANSFER',
      details: {
        sourceFund: {
          fundManager: { name: 'Swedbank' },
          isin: 'EE3600109442',
          name: 'Swedbank II',
          managementFeeRate: 0.0034,
          pillar: 2,
          ongoingChargesFigure: 0.0046,
          nav: 1,
          status: 'ACTIVE',
          inceptionDate: '2017-01-01',
        },
        exchanges: [
          {
            targetFund: {
              name: 'Tuleva Maailma Aktsiate Pensionifond',
              fundManager: { name: 'Tuleva' },
              pillar: 2,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0049,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: 'EE123123123',
            amount: 0.4,
          },
        ],
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 3,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'TRANSFER',
      details: {
        sourceFund: {
          fundManager: { name: 'Swedbank' },
          isin: 'EE3600109442',
          name: 'Swedbank II',
          managementFeeRate: 0.0034,
          pillar: 3,
          ongoingChargesFigure: 0.0096,
          nav: 1,
          status: 'ACTIVE',
          inceptionDate: '2017-01-01',
        },
        exchanges: [
          {
            targetFund: {
              name: 'Tuleva Maailma Aktsiate Pensionifond',
              fundManager: { name: 'Tuleva' },
              pillar: 3,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0049,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 500,
          },
          {
            targetFund: {
              name: 'Swedbanki Mõni Teine fond',
              fundManager: { name: 'Tuleva' },
              pillar: 3,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0049,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 500,
          },
        ],
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 3,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'TRANSFER',
      details: {
        sourceFund: {
          fundManager: { name: 'Swedbank' },
          isin: 'EE3600109442',
          name: 'Swedbank II',
          managementFeeRate: 0.0034,
          pillar: 2,
          ongoingChargesFigure: 0.0096,
          nav: 1,
          status: 'ACTIVE',
          inceptionDate: '2017-01-01',
        },
        exchanges: [
          {
            targetFund: {
              name: 'Swedbanki Mõni Teine fond',
              fundManager: { name: 'Swedbank' },
              pillar: 2,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0149,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 0.5,
          },
        ],
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },
    {
      id: 19,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      type: 'TRANSFER',
      details: {
        sourceFund: {
          fundManager: { name: 'Swedbank' },
          isin: 'EE3600109442',
          name: 'Swedbank II',
          managementFeeRate: 0.0034,
          pillar: 2,
          ongoingChargesFigure: 0.0096,
          nav: 1,
          status: 'ACTIVE',
          inceptionDate: '2017-01-01',
        },
        exchanges: [
          {
            targetFund: {
              name: 'Swedbanki Mõni Teine fond',
              fundManager: { name: 'Swedbank' },
              pillar: 2,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0149,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 0.5,
          },
          {
            targetFund: {
              name: 'Luminori Mõni Kolmas fond',
              fundManager: { name: 'Luminor' },
              pillar: 2,
              isin: 'EE3600001707',
              ongoingChargesFigure: 0.0149,
              nav: 1,
              managementFeeRate: 0.0049,
              status: 'ACTIVE',
              inceptionDate: '2020-01-01',
            },
            targetPik: null,
            amount: 0.5,
          },
        ],
        cancellationDeadline: moment().add(7, 'days').toISOString(),
      },
    },

    {
      type: 'SAVING_FUND_PAYMENT',
      id: 123456789,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      details: {
        amount: 100,
        currency: 'EUR',
        paymentId: 'payment-123',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        cancelledAt: null,
        fulfillmentDeadline: moment().add(14, 'days').toISOString(),
      },
    },
    {
      type: 'SAVING_FUND_PAYMENT',
      id: 123456789,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      details: {
        amount: 100,
        currency: 'EUR',
        paymentId: 'payment-123',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        cancelledAt: moment().toISOString(),
        fulfillmentDeadline: moment().add(14, 'days').toISOString(),
      },
    },
  ],
  SAVINGS_FUND: [
    {
      type: 'SAVING_FUND_PAYMENT',
      id: 900001,
      status: 'PENDING',
      creationTime: moment().subtract(1, 'hours').toISOString(),
      details: {
        amount: 250,
        currency: 'EUR',
        paymentId: 'payment-sf-1',
        cancellationDeadline: moment().add(7, 'days').toISOString(),
        cancelledAt: null,
        fulfillmentDeadline: moment().add(14, 'days').toISOString(),
      },
    },
  ] as Application[],
};
